<template>
  <div
    class="box-border w-full bg-[#F5F6F7]"
    :class="isPC ? 'py-[40px] px-[40px]' : 'rounded-[20px] px-[24px] py-[48px]'"
  >
    <!-- 顶部：状态标签 + 参与人数 -->
    <PredictEventHeader
      :status="session.status"
      :participant-count="session.participantCount"
    />

    <!-- 股票信息插槽 -->
    <slot name="stock-info" />

    <!-- PC：白色内卡片包裹问题+按钮 -->
    <div
      v-if="isPC"
      class="mt-[20px] rounded-[16px] bg-white px-[60px] py-[40px]"
    >
      <p class="text-center text-[32px] leading-[36px] text-[#121212]">
        {{ $label(session.question && session.question.title) }}
      </p>
      <UpDownDualButtons
        class="mt-[40px]"
        :options="options"
        :up-color="upColor"
        :down-color="downColor"
        :selected-code="myVoteCode"
        :settled="settled"
        :winner-code="winnerCode"
        @select="handleSelect"
      />
    </div>

    <!-- H5 -->
    <template v-else>
      <p class="mt-[40px] text-[32px] leading-[36px] text-[#121212]">
        {{ $label(session.question && session.question.title) }}
      </p>
      <UpDownDualButtons
        class="mt-[24px]"
        :options="options"
        :up-color="upColor"
        :down-color="downColor"
        :selected-code="myVoteCode"
        :settled="settled"
        :winner-code="winnerCode"
        @select="handleSelect"
      />
    </template>

    <!-- 页脚：倒计时 / 公布 / 结果 -->
    <PredictFooter
      :class="isPC ? 'mt-[32px]' : 'mt-[50px]'"
      :status="session.status"
      :deadline="session.deadline"
      :resolve-at="session.resolveAt"
      :result="result"
      @countdown-finish="emit('countdown-finish')"
    />
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { useLocaleString, useFegoPageInfo, UpDownTypes } from '@ark/web-shared/use';
import { PREDICT_STATUS } from '../../shared/types';
import type { PredictOption, PredictResult, PredictSession } from '../../shared/types';
import type { MarketStatsResponse } from '@ark/predict-shared';
import { COLOR_GREEN, COLOR_RED } from '../../shared/constants';
import PredictEventHeader from './header.vue';
import UpDownDualButtons from './up-down-dual-buttons.vue';
import PredictFooter from './footer.vue';
import { getPredictResult } from '../utils/predict-result';
const __sfc_main = {};
__sfc_main.props = {
  session: {
    key: "session",
    required: true,
    type: null
  },
  marketStats: {
    key: "marketStats",
    required: false,
    type: null
  },
  upDownType: {
    key: "upDownType",
    required: false,
    type: Number
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const $label = useLocaleString();
  const {
    isPC
  } = useFegoPageInfo();
  const options = computed<PredictOption[]>(() => {
    const raw = props.session.answerSpec && props.session.answerSpec.options;
    if (!raw) return [];
    return raw.map(o => ({
      code: o.code,
      label: o.label,
      percent: o.percent
    }));
  });
  const myVoteCode = computed(() => props.session.myVoteCode);
  const winnerCode = computed(() => props.session.correctValue);
  const settled = computed(() => props.session.status === PREDICT_STATUS.SETTLED);
  const result = computed<PredictResult | null>(() => getPredictResult(settled.value, props.session.settleStatus));
  const upColor = computed(() => props.upDownType === UpDownTypes.RedUpGreenDown ? COLOR_RED : COLOR_GREEN);
  const downColor = computed(() => props.upDownType === UpDownTypes.RedUpGreenDown ? COLOR_GREEN : COLOR_RED);
  function handleSelect(option: PredictOption) {
    emit('select', option);
  }
  return {
    emit,
    $label,
    isPC,
    options,
    myVoteCode,
    winnerCode,
    settled,
    result,
    upColor,
    downColor,
    handleSelect
  };
};
__sfc_main.components = Object.assign({
  PredictEventHeader,
  UpDownDualButtons,
  PredictFooter
}, __sfc_main.components);
export default __sfc_main;
</script>
